import { render, staticRenderFns } from "./ed-subject-builder-sidebar.component.vue?vue&type=template&id=6477d9ec&scoped=true&"
import script from "./ed-subject-builder-sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-sidebar.component.scss?vue&type=style&index=0&id=6477d9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6477d9ec",
  null
  
)

export default component.exports